'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleBuilder = exports.remSizes = exports.getWidthRem = exports.getRemPx = exports.getWidthPx = exports.getWindowSize = exports.styles = undefined;

var _property2 = require('lodash/property');

var _property3 = _interopRequireDefault(_property2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _divide2 = require('lodash/divide');

var _divide3 = _interopRequireDefault(_divide2);

var _utils = require('./utils');

Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});
exports.sizeChecker = sizeChecker;
exports.getSizeId = getSizeId;

var _reselect = require('reselect');

var _styleBuilder = require('./styleBuilder');

var _styleBuilder2 = _interopRequireDefault(_styleBuilder);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = _styles2.default;

var getWindowSize = exports.getWindowSize = (0, _property3.default)('windowSize');
var getWidthPx = exports.getWidthPx = (0, _flow3.default)(getWindowSize, (0, _property3.default)('width'));
var getRemPx = exports.getRemPx = (0, _flow3.default)(getWindowSize, (0, _property3.default)('rem'));
var getWidthRem = exports.getWidthRem = (0, _reselect.createSelector)(getWidthPx, getRemPx, _divide3.default);
var remSizes = exports.remSizes = [{ min: 90, id: 'wide' }, { min: 70, id: 'goldilocks' }, { max: 50, id: 'skinny' }];
function sizeChecker(widthRem) {
  return function (_ref) {
    var min = _ref.min,
        max = _ref.max;

    if (min) return widthRem >= min;
    if (max) return widthRem <= max;
    return true;
  };
}
function getSizeId(state) {
  if (!getWindowSize(state).rem) return remSizes[0].id;
  var widthRem = getWidthRem(state);
  return widthRem < 50 ? 'skinny' : 'wide';
  // return get(find(remSizes, sizeChecker(widthRem)), 'id', remSizes[2].id)
}
exports.styleBuilder = _styleBuilder2.default;
exports.default = (0, _styleBuilder2.default)(styles);


//////////////////
// WEBPACK FOOTER
// ./~/cape-style/lib/index.js
// module id = 12
// module chunks = 0